import React from 'react';
import { Route } from 'react-router';
import Page from './Chatbot';

const routes = <Route path="/" component={Page} />;

export default routes;
